import React, { FC, useRef } from 'react';
import { motion } from 'framer-motion';
import fadeIn from '../../animations/fadeIn';
import Input from '../Input/Input';

const commaSeparate = (num: number) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

interface PointsEntryProps {
  index: number;
  partner: any;
  currentPoints: any;
  onValueChanged: (e: React.ChangeEvent<HTMLInputElement>) => void;
  updatePartnerPoints: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const PointsEntry: FC<PointsEntryProps> = ({
  partner,
  index,
  currentPoints,
  onValueChanged,
  updatePartnerPoints,
}) => {
  const inputField = useRef<any>();

  const onAnyPressed = () => {
    inputField.current.focus();
  };

  return (
    <motion.div
      variants={fadeIn(index * 0.1)}
      initial='hidden'
      animate='enter'
      exit='exit'
      key={partner.name}
      className='partner'
    >
      <img
        src={partner.logo}
        alt={partner.name}
        className='aspect-square bg-white w-14 rounded-xl'
        onClick={onAnyPressed}
      />
      <div>
        <p onClick={onAnyPressed}>{partner.name}</p>
        <Input
          placeholder='Enter points...'
          onEnded={updatePartnerPoints}
          onChange={onValueChanged}
          name={partner.name}
          value={
            currentPoints[partner.name]
              ? commaSeparate(currentPoints[partner.name])
              : ''
          }
          className='w-[170px]'
          inputRef={inputField}
        />
      </div>
    </motion.div>
  );
};

export default PointsEntry;
